import { ACCOUNT_LOGOUT } from '../../actionTypes/session';

export const logoutAction = () => ({
  type: ACCOUNT_LOGOUT,
});
